import Cookies from 'js-cookie';

import { CookiesConfig } from '@configs';
import { getCookieCifra, LoggerHelper } from '@helpers';

import { helpers } from './useCookies.helper';

export const useBrowserInfoCookie = () => {
	const browserInfoCookieName = CookiesConfig.browserInfo;
	const browserInfoCookieDomain = CookiesConfig.domain;
	/* 1 year in minutes */
	const browserInfoCookieExpires = 525600;

	/**
	 * Initializes and stores a browser info cookie if it doesn't already exist.
	 * Generates a new encrypted value using the user's alias and sets it with expiration metadata.
	 */
	const initBrowserInfoCookie = async (userAlias: string): Promise<string> => {
		let browserInfoCookieValue = getBrowserInfoCookie();

		/* only set the cookie if not previously stored */
		if (!browserInfoCookieValue) {
			/* in localhost will only work with http://localhost:3000 for Web Crypto API support */
			browserInfoCookieValue = await getCookieCifra(userAlias);
			Cookies.set(browserInfoCookieName, browserInfoCookieValue, {
				domain: browserInfoCookieDomain,
				expires: helpers.getCookieExpirationDate(browserInfoCookieExpires),
			});
		}

		LoggerHelper.log('Cookies', 'useBrowserInfoCookie > initBrowserInfoCookie:', {
			browserInfoCookieName,
			browserInfoCookieDomain,
			browserInfoCookieExpires,
			browserInfoCookieValue,
		});

		return browserInfoCookieValue;
	};

	const getBrowserInfoCookie = (): string => {
		return Cookies.get(browserInfoCookieName) || '';
	};

	return {
		initBrowserInfoCookie,
		getBrowserInfoCookie,
	};
};
